import { Separator } from '@betterment/samba-react';

import { ColumnShimmer } from '../../../../Shared/Components/ColumnShimmer';
import { BorderedBox } from '../BorderedBox';
import { BoxTitle } from '../BoxTitle';

export const AccountDetailsLoading: React.FC = () => {
  return (
    <BorderedBox css={{ pb: 'space.200' }}>
      <BoxTitle>Account details</BoxTitle>
      <Separator />
      <ColumnShimmer
        columns={2}
        data-testid="account-name-shimmer"
        leadingWidth="140px"
        trailingWidth="140px"
        css={{ paddingY: 'space.200' }}
      />
    </BorderedBox>
  );
};
